import { useEffect } from "react";
import { Routes } from "../../../utils/constants";
import { useNavigate } from "react-router-dom";
import { useGlobalState } from "../../../contexts/GlobalContext";
import { logger } from "../../../utils/helpers/logger";
import { isAdverTimesBulkDownloadFlow } from "../../../utils/helpers/function";

// WARNING: そもそもLayoutでリダイレクトのロジックを持つべきはなくて、専用のcontextを作ってそこに持たせるべき
type UseLayoutNavigationParams = {
  urlParams: {
    signUp: string | null;
    surveyId: string | null;
    error: string | null;
    errorDescription: string | null;
    returnTo?: string | null;
  };
}
export const useLayoutNavigation = (params: UseLayoutNavigationParams) => {
  const { urlParams } = params;
  const { globalState } = useGlobalState();
  const navigate = useNavigate();
  const { surveyId, error, errorDescription } = urlParams;
  useEffect(() => {
    if (!globalState.user && urlParams.signUp === "true") {
      console.log("Navigating to REGISTER");
      navigate(Routes.REGISTER);
    }

    return () => {};
  }, [globalState.user, urlParams.signUp]);

  useEffect(() => {
    if (error && errorDescription) {
      console.log("Navigating to USERGUEST due to error");
      navigate(Routes.USERGUEST);
    }

    return () => {};
  }, [error, errorDescription]);

  useEffect(() => {
    if (surveyId && globalState.isAuthenticated) {
      // SDK_WEB-1374: bulk-download inflow only — do not force /user/survey
      const returnTo =
        urlParams.returnTo || localStorage.getItem("loginCallBackUrl");
      if (returnTo && isAdverTimesBulkDownloadFlow(returnTo)) {
        logger(
          "[useLayoutNavigation]",
          "Skipping SURVEY redirect for AdverTimes bulk-download returnto"
        );
        return;
      }
      console.log("Navigating to SURVEY with surveyId:", surveyId);
      navigate(Routes.SURVEY, { state: { survey_id: surveyId } });
    }

    return () => {};
  }, [surveyId, globalState.isAuthenticated, urlParams.returnTo]);

  // XXX: localStorageを参照しているため、動作のタイミングがわかりづらい
  useEffect(() => {
    logger("[useLayoutNavigation]", "Redirecting to USER");
    logger("[useLayoutNavigation]", globalState.isAuthenticated, location.pathname);
    if (
      globalState.isAuthenticated &&
      Routes.USERGUEST === location.pathname &&
      !localStorage.getItem("survey_url") &&
      !localStorage.getItem("loginCallBackUrl")
    ) {
      navigate(Routes.USER);
    }

    return () => {};
  }, [globalState.isAuthenticated, location.pathname]);
}
